import { Injectable } from '@angular/core';
import { Lifecycle, Metrics, Parameters } from '@firebolt-js/sdk';

@Injectable({
  providedIn: 'root',
})
export class FireboltService {
  constructor() {}

  /**
   * Call the initialization function
   * TODO: start to listen the deeplink intents
   * TODO: start to listen the background-foreground changes
   */
  init() {
    Parameters.initialization(); // response contains lmt and privacy policy info
  }

  /**
   * Marks the app ready to show to the user
   */
  ready() {
    Lifecycle.ready();
  }

  /**
   * Close the app by application normal ending
   */
  close() {
    Lifecycle.close(Lifecycle.CloseReason.DONE);
  }

  /**
   * Close the app by user action
   */
  exit() {
    Lifecycle.close(Lifecycle.CloseReason.USER_EXIT);
  }

  /**
   * Close the app by remote exit button
   */
  closeByButton() {
    Lifecycle.close(Lifecycle.CloseReason.REMOTE_BUTTON);
  }

  /**
   * Close the app by error
   */
  closeWithError() {
    Lifecycle.close(Lifecycle.CloseReason.ERROR);
  }

  /**
   *
   * @param errorType
   * @param errorCode
   * @param errorMessage
   * @param isVisible
   */
  reportError(errorType: string, errorCode: string, errorMessage: string, isVisible: boolean = true) {
    Metrics.error((errorType as Metrics.ErrorType) ?? Metrics.ErrorType.OTHER, errorCode, errorMessage, isVisible);
  }

  /**
   * Report an error
   */
  reportPlayerError(errorCode: string | number, errorMessage, isVisible = true) {
    Metrics.error(Metrics.ErrorType.MEDIA, errorCode?.toString(), errorMessage, isVisible);
  }

  /**
   * Report player start playing content
   */
  startContent() {
    Metrics.startContent();
  }

  /**
   * Report player stop playing content
   */
  stopContent() {
    Metrics.stopContent();
  }
}
